
<div class="videostore-language-container">
  <div class="language-selector-heading">
    <p>Welcome - Bienvenue - Bienvenue - ਸੁਆਗਤ ਹੈ - 欢迎 - أهلا بك - خوش آمدی - 歡迎</p>

  </div>
  <div class="language-selector-subheading">
    <p>Please select the language you would like to use, We'll save your choice and automatically re-apply it next time you visit</p>
  </div>
  <div class="h-30"></div>
  <div class="language-selector-languages">
    @for (lang of languages; track lang) {
      <div class="language-card w-30p" (click)="setLanguage(lang.id)">
        {{lang.description}}
      </div>
    }
  </div>
</div>

